import React from "react";
import { Tooltip } from "@mui/material";
import TourIcon from "@mui/icons-material/Tour";
import { useTour } from "../../context/TourContext";
import "./TourButton.css";
import { useTranslation } from "react-i18next";

const TourButton = () => {
    const { startTour, hasTourSteps } = useTour();
    const { t } = useTranslation();
    
    const shouldShowButton = hasTourSteps();
    
    if (!shouldShowButton) {
        return null;
    }

    const handleClick = () => {
        if (startTour) {
            startTour();
        } else {
            console.warn("Tour context not available");
        }
    };

    return (
        <Tooltip title={t("UI_TEXT.TOOLTIP_START_APP_TOUR")} placement="left" arrow>
            <div
                className="tour-icon"
                onClick={handleClick}
                role="button"
                aria-label={t("UI_TEXT.TOOLTIP_START_APP_TOUR")}
            >
                <TourIcon />
            </div>
        </Tooltip>
    );
};

export default TourButton;
